import { render, staticRenderFns } from "./createShop.vue?vue&type=template&id=1df89d70&scoped=true"
import script from "./createShop.vue?vue&type=script&lang=js"
export * from "./createShop.vue?vue&type=script&lang=js"
import style0 from "./createShop.vue?vue&type=style&index=0&id=1df89d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df89d70",
  null
  
)

export default component.exports